import { Link } from '@mui/material';
import BlockData from '../../../../models/BlockData';
import CroppedImage from '../../../CroppedImage';
import ImageSettingsModal from '../../../Modals/ImageSettingsModal/ImageSettingsModal';
import BlockImageListItemData from '../BlockImageListItemData';

interface BlockImageListItemProps {
  item: BlockImageListItemData;
  isTemplate: boolean;
  isEditing: boolean;
  blockData: BlockData[];
  onUpdate: (item: BlockImageListItemData) => void;
}

const BlockImageListItem = ({
  item, isTemplate, isEditing, blockData, onUpdate,
}: BlockImageListItemProps) => {
  const { image } = item;
  return (
    <ImageSettingsModal imageListItem={item} disabled={isTemplate || !isEditing} blockData={blockData} onConfirm={onUpdate}>
      { (item.link && !isEditing) ? (
        <Link
          sx={{
            width: '100%',
            height: '100%',
          }}
          href={item.link.linkData.url}
          target={item.link.linkData.openType}
          rel="noreferrer"
        >
          <CroppedImage image={image} settings={image.settings} sizeInPercentage={{ width: '248px', height: '165px' }} />
        </Link>
      ) : (
        <CroppedImage image={image} settings={image.settings} sizeInPercentage={{ width: '248px', height: '165px' }} />
      )}
    </ImageSettingsModal>
  );
};

export default BlockImageListItem;
